let pally_skipLink = document.querySelector('.pally-skip-link');
pally_skipLink.addEventListener('click', function(e) {
  document.querySelector(pally_skipLink.getAttribute('href')).focus();
});
